import { isNotNilNotEmpty } from "@/utils/shared.utils";

const enumsToMultiSelectOptions = ({
  enumOptions,
  valueField,
}: {
  enumOptions?: CodedEnumOption[];
  valueField: keyof CodedEnumOption;
}): MultiSelectOption[] => {
  const normalizedOptions = enumOptions || [];
  return normalizedOptions.map((option) => ({
    displayText: option.label,
    value: option[valueField],
  }));
};

const usStatesEnumToMultiSelectOptions = (
  usStatesEnum?: UsStateEnumOption[],
): MultiSelectOption[] => {
  const normalizedOptions = usStatesEnum || [];
  return normalizedOptions.map((option) => ({
    displayText: option.label,
    value: option.externalId,
  }));
};

const getUsStateFullName = ({
  abbreviation,
  usStates,
}: {
  abbreviation: string;
  usStates?: UsStateEnumOption[];
}): string => {
  const safeUsStates = usStates ?? [];
  const result = safeUsStates.find(
    (usState) => usState.externalId === abbreviation,
  );

  if (!isNotNilNotEmpty(result)) {
    // if any issues, fallback to the passed in argument
    return abbreviation;
  }
  return result.label;
};

export {
  enumsToMultiSelectOptions,
  getUsStateFullName,
  usStatesEnumToMultiSelectOptions,
};
